(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("MKAppLoader"), require("React"), require("Immutable"), require("MKUtils"), require("ReactDom"));
	else if(typeof define === 'function' && define.amd)
		define(["MKAppLoader", "React", "Immutable", "MKUtils", "ReactDom"], factory);
	else if(typeof exports === 'object')
		exports["MKComponent"] = factory(require("MKAppLoader"), require("React"), require("Immutable"), require("MKUtils"), require("ReactDom"));
	else
		root["MKComponent"] = factory(root["MKAppLoader"], root["React"], root["Immutable"], root["MKUtils"], root["ReactDom"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mk_app_loader__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_immutable__, __WEBPACK_EXTERNAL_MODULE_mk_utils__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 